import { Box, styled } from "@mui/material";
import { Tabs } from "antd";
import React, { useState } from "react";
import ClientTable from "./clientTable";
import DomainTable from "./domainTable";
import EngagementTable from "./engagementTable";
import WorkflowTable from "./workflowTable";

const AdminContainer = styled(Box)(({ openDrawer }) => ({
  marginLeft: openDrawer ? 240 : 80,
  width: openDrawer ? "calc(100% - 255px)" : "calc(100% - 85px)",
  // border: openDrawer ? "2px solid green" : "2px solid blue",
  height: "calc(100vh - 90px)",
}));
const items = [
  {
    key: "Domain",
    label: "Function",
    children: "Domain",
  },
  {
    key: "Client",
    label: "Sub-Function",
    children: "Client",
  },
  {
    key: "Engagement",
    label: "Pipeline",
    children: "Engagement",
  },
  {
    key: "Workflow",
    label: "Workflow",
    children: "Workflow",
  },
];

const Admin = ({ openDrawer }) => {
  const [activeTab, setActiveTab] = useState("Domain");

  const onChange = (key) => {
    setActiveTab(key);
  };

  return (
    <AdminContainer openDrawer={openDrawer}>
      <Tabs activeKey={activeTab} onChange={onChange} style={{ fontWeight: 'bold', marginLeft: 20 }}>
        {items.map((item) => (
          <Tabs.TabPane tab={item.label} key={item.key}>
            {item.key === "Client" && <ClientTable />}
            {item.key === "Domain" && <DomainTable />}
            {item.key === "Engagement" && <EngagementTable />}
            {item.key === "Workflow" && <WorkflowTable />}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </AdminContainer>
  );
};

export default Admin;
